module.exports = __webpack_public_path__ + "img/bg_avatar_female_33.7a331c0e.png";